import { createTransform } from 'redux-persist';
import { dateReviver } from '@lialo/common/lib/date';

const replacer = (key: string, value: any) => (value instanceof Date ? value.toISOString() : value);

export const dateTransform: any = createTransform(
  toDeshydrate => JSON.stringify(toDeshydrate, replacer),
  toRehydrate => JSON.parse(toRehydrate, dateReviver)
);
